import { CommonEnums } from '../../common.enums';

export class Native_Db_Seq {
    native_Db_Seq_Id: number;
    nm: string;
    aliasNm: string;
    seqParamNm: string;
    description: string;
    ver: string;
    nativeDbTyp_Id: number;
    valid_Cd: string;
    updateDt: Date;
    updateBy: string;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.native_Db_Seq_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.aliasNm = CommonEnums.defaults.STRING_EMPTY;
        this.seqParamNm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.nativeDbTyp_Id = CommonEnums.defaults.LONG_VAL;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
    }

    copy(): Native_Db_Seq {
        let native_Db_SeqTmp: Native_Db_Seq = new Native_Db_Seq();

        native_Db_SeqTmp.native_Db_Seq_Id = this.native_Db_Seq_Id;
        native_Db_SeqTmp.nm = this.nm;
        native_Db_SeqTmp.aliasNm = this.aliasNm;
        native_Db_SeqTmp.seqParamNm = this.seqParamNm;
        native_Db_SeqTmp.description = this.description;
        native_Db_SeqTmp.ver = this.ver;
        native_Db_SeqTmp.nativeDbTyp_Id = this.nativeDbTyp_Id;
        native_Db_SeqTmp.valid_Cd = this.valid_Cd;
        native_Db_SeqTmp.updateDt = this.updateDt;
        native_Db_SeqTmp.updateBy = this.updateBy;

        return native_Db_SeqTmp;
    }

    copyFrom(native_Db_SeqTmp: Native_Db_Seq): void {
        this.native_Db_Seq_Id = native_Db_SeqTmp.native_Db_Seq_Id;
        this.nm = native_Db_SeqTmp.nm;
        this.aliasNm = native_Db_SeqTmp.aliasNm;
        this.seqParamNm = native_Db_SeqTmp.seqParamNm;
        this.description = native_Db_SeqTmp.description;
        this.ver = native_Db_SeqTmp.ver;
        this.nativeDbTyp_Id = native_Db_SeqTmp.nativeDbTyp_Id;
        this.valid_Cd = native_Db_SeqTmp.valid_Cd;
        this.updateDt = native_Db_SeqTmp.updateDt;
        this.updateBy = native_Db_SeqTmp.updateBy;
    }

    compare(native_Db_SeqTmp: Native_Db_Seq): string {
        let native_Db_SeqString: string = this.toString(false);
        let native_Db_SeqTmpString: string = native_Db_SeqTmp.toString(false);

        if (native_Db_SeqString != native_Db_SeqTmpString) {
            return native_Db_SeqString + ', ' + native_Db_SeqTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true) {
        let str: string = "Native_Db_Seq [native_Db_Seq_Id=" + this.native_Db_Seq_Id + ", nm=" + this.nm +
            ", aliasNm=" + this.aliasNm + ", seqParamNm=" + this.seqParamNm +
            ", description=" + this.description + ", nativeDbTyp_Id=" + this.nativeDbTyp_Id +
            ", valid_Cd=" + this.valid_Cd;

        if (isNotCompare) {
            str += ", ver=" + this.ver + ", updateDt=" + this.updateDt + ", updateBy=" + this.updateBy;
        }

        str += "]";
        return str;
    }
}